module.exports = __webpack_public_path__ + "static/img/zanwu.ada8dd65.png";